export function useCompanyTheme() {
  const user = useUser()
  const appConfig = useAppConfig()

  watchEffect(() => {
    const companyKey = user.companyKey.value

    appConfig.ui.colors.primary = companyKey === 'FIN' ? 'fin' : 'fpc'
  })
}
